import _ from 'lodash';
import { getSevenImperative, getSevenImperatives, getImperativesStages } from './data';

export function getDealItemsAtRisk(deal){
  if(!deal){
    return [];
  }

  let itemsAtRisk = [];

  _.forOwn(deal.imperativeTasks, (value, key) => {
    if(value === 'failed'){
      itemsAtRisk.push(key);
    }
  });
  _.forOwn(deal.funnelTasks, (value, key) => {
    if(value === 'failed'){
      itemsAtRisk.push(key);
    }
  });

  return itemsAtRisk;
}

function getScoreForImperativeTask(id, status){
  const statusMultiplier = (status === 'complete' ? 1 : (status === 'failed' ? -1 : 0));

  switch(id){
    default: return 1 * statusMultiplier;
    case '111': return 17 * statusMultiplier;
    case '112': return 18 * statusMultiplier;
    case '113': return 22 * statusMultiplier;
    case '114': return 18 * statusMultiplier;
    case '115': return 21 * statusMultiplier;

    case '211': return 18 * statusMultiplier;
    case '212': return 23 * statusMultiplier;
    case '213': return 19 * statusMultiplier;
    case '214': return 23 * statusMultiplier;
    case '215': return 21 * statusMultiplier;

    case '311': return 13 * statusMultiplier;
    case '312': return 14 * statusMultiplier;
    case '313': return 10 * statusMultiplier;
    case '314': return 10 * statusMultiplier;
    case '315': return 12 * statusMultiplier;

    case '411': return 11 * statusMultiplier;
    case '412': return 15 * statusMultiplier;
    case '413': return 50 * statusMultiplier;//Prospect is advising me on win strategy
    case '414': return 17 * statusMultiplier;
    case '415': return 20 * statusMultiplier;

    case '511': return 10 * statusMultiplier;
    case '512': return 10 * statusMultiplier;
    case '513': return 10 * statusMultiplier;
    case '514': return 11 * statusMultiplier;
    case '515': return 11 * statusMultiplier;

    case '611': return 22 * statusMultiplier;
    case '612': return 30 * statusMultiplier;
    case '613': return 28 * statusMultiplier;
    case '614': return 26 * statusMultiplier;
    case '615': return 25 * statusMultiplier;

    case '711': return 12 * statusMultiplier;
    case '712': return 18 * statusMultiplier;
    case '713': return 11 * statusMultiplier;
    case '714': return 19 * statusMultiplier;
    case '715': return 16 * statusMultiplier;

  }
}
function getScoreForFunnelTask(id, status){
  const statusMultiplier = (status === 'complete' ? 1 : (status === 'failed' ? -1 : 0));

  switch(id){
    default: return 1 * statusMultiplier;
    //objectives
    case '101': return 13 * statusMultiplier;
    case '102': return 15 * statusMultiplier;
    case '103': return 19 * statusMultiplier;
    case '104': return 16 * statusMultiplier;
    case '105': return 14 * statusMultiplier;
    case '106': return 15 * statusMultiplier;
    case '107': return 23 * statusMultiplier;
    // case '108': return 0 * statusMultiplier;
    // case '109': return 0 * statusMultiplier;
    // case '110': return 0 * statusMultiplier;
    // case '111': return 0 * statusMultiplier;
    // case '112': return 0 * statusMultiplier;
    // case '113': return 0 * statusMultiplier;
    // case '114': return 0 * statusMultiplier;
    case '115': return 30 * statusMultiplier;//Proposal presented, 24 from calc, increasing manually
    // case '116': return 0 * statusMultiplier;//duplicated as imperative task 6.2
    case '117': return 50 * statusMultiplier;//Terms and fees negotiated, 31 from calc, increasing manually

    case '118': return 0;//This indicates the deal is closed - confidence => 100%

    //reciprocations
    case '201': return 16 * statusMultiplier;
    case '202': return 17 * statusMultiplier;
    // case '203':
    // case '204':
    case '205': return 19 * statusMultiplier;
    // case '206':
    // case '207':
    // case '208':
    case '209': return 24 * statusMultiplier;
    // case '210':
    // case '211':
    case '212': return 15 * statusMultiplier;
    // case '213':
    case '214': return 26 * statusMultiplier;
    case '215': return 30 * statusMultiplier;
    case '216': return 30 * statusMultiplier;
    //case '217':
    // case '218':
  }
}

function getScoreForImperativeSection(sectionNumber){
  switch(sectionNumber){
    default: return 50;
    case '1': return 50;
    case '2': return 50;
    case '3': return 50;
    case '4': return 50;
    case '5': return 25;//least predictive
    case '6': return 200;//most predictive
    case '7': return 50;
  }
}

function getTotalAvailableScore(){
  return 1483;
}

export function getDealCompletion(deal){

  if(!deal){
    return {
      totalScore: 0,
      totalItems: 0,
      completedItems: 0,
      imperativeTasksComplete: 0,
      imperativeTasksAtRisk: 0,
      funnelTasksComplete: 0,
      funnelTasksAtRisk: 0,
      completedImperatives: 0,
      completedImperativesBonus: 0,
      fractionComplete: 0,
      percentComplete: 0,
      confidence: 0,
      active: false,
    }
  }

  //ensure these are set
  const dealImperativeTasks = deal.imperativeTasks || {};
  const dealFunnelTasks = deal.funnelTasks || {};

  // console.log('dealImperativeTasks: ', dealImperativeTasks);
  // console.log('dealFunnelTasks: ', dealFunnelTasks);

  // console.log('dealImperativeTasks: ', dealImperativeTasks);
  // console.log('dealFunnelTasks: ', dealFunnelTasks);

  const imperatives = getSevenImperatives();
  const stages = getImperativesStages();

  let totalScore = 0;
  let imperativeTasksComplete = 0;
  let imperativeTasksAtRisk = 0;
  let completedImperativesBonus = 0;
  let completedImperatives = 0;

  _.each(imperatives, imperative => {
    let thisImperativeCompletedCount = 0;

    //console.log('checking: ', imperative);

    _.each(imperative.tasks, imperativeTask => {

      const taskId = imperativeTask.id;

      //old version of tracking statuses just used the status name instead of an object with a status property, handle both cases here
      const dealImperativeTaskStatus = dealImperativeTasks[taskId] && dealImperativeTasks[taskId].status || dealImperativeTasks[taskId];

      //console.log('dealImperativeTaskStatus: ', dealImperativeTaskStatus);

      totalScore += getScoreForImperativeTask(taskId, dealImperativeTaskStatus);

      if(dealImperativeTaskStatus === 'complete'){
        imperativeTasksComplete += 1;
        thisImperativeCompletedCount += 1;
      }
      else if(dealImperativeTaskStatus === 'failed'){
        imperativeTasksAtRisk += 1;
      }
    });

    //entire imperative complete!
    //add bonus
    if(thisImperativeCompletedCount === 5){
      const thisImperativeBonus = getScoreForImperativeSection(imperative.id);
      completedImperatives += 1;
      completedImperativesBonus += thisImperativeBonus;
      totalScore += thisImperativeBonus;
    }
  });

  let funnelTasksComplete = 0;
  let funnelTasksAtRisk = 0;

  _.each(_.union(stages.objectives, stages.reciprocations), funnelTask => {
    // let completedCount = 0;
    // let imperativeScoreTotal = 0;

    const taskId = funnelTask.id;

    let dealFunnelTaskStatus = 'incomplete';

    if(funnelTask.imperativeTaskId){
      //TODO figure out a better way of managing these relationships
      //tracking this as imperative. Don't track here.
      //lookup on imperative tasks, since that's where this is tracked!
      //dealFunnelTaskStatus = dealImperativeTasks[taskId];
    }
    else if(funnelTask.imperativeId){
      //tracking as imperative, don't track here
    }
    else{
      //old version of tracking statuses just used the status name instead of an object with a status property, handle both cases here
      dealFunnelTaskStatus = dealFunnelTasks[taskId] && dealFunnelTasks[taskId].status || dealFunnelTasks[taskId];
    }

    totalScore += getScoreForFunnelTask(taskId, dealFunnelTaskStatus);

    if(dealFunnelTaskStatus === 'complete'){
      funnelTasksComplete += 1;
    }
    else if(dealFunnelTaskStatus === 'failed'){
      funnelTasksAtRisk += 1;
    }
  });

  const completedItems = imperativeTasksComplete + funnelTasksComplete;
  const totalImperativeTasks = 35;
  const totalFunnelTasks = 10 + 8;//- Imperative completion, -Seller objective duplicated (116/612), - Buyer reciprocations counted twice
  const totalItems = totalImperativeTasks + totalFunnelTasks;

  const fractionComplete = completedItems / totalItems;
  const percentComplete = Math.round(fractionComplete * 100.);
  //const confidence = Math.round(Math.pow(fractionComplete, 1 + fractionComplete) * 100.);

  let confidence = Math.max(Math.ceil(totalScore / getTotalAvailableScore() * 100.), 0);//max 100 (esp since I6 is worth > 10%, and is hugely predictive: 98% of time copmplete, deal is won), no exponential scaling

  //if contract signed, confidence => 100
  const contractSignedFunnelTask = dealFunnelTasks['118'];

  if(deal.status === 'won' || contractSignedFunnelTask && contractSignedFunnelTask === 'complete'){
    confidence = 100;
  }

  return {
    totalScore,
    completedItems,
    totalImperativeTasks,
    totalFunnelTasks,
    totalItems,
    imperativeTasksComplete,
    imperativeTasksAtRisk,
    funnelTasksComplete,
    funnelTasksAtRisk,
    completedImperatives,
    completedImperativesBonus,
    fractionComplete,
    percentComplete,
    confidence,
    active: fractionComplete > 0 || imperativeTasksAtRisk > 0 || funnelTasksAtRisk > 0,
  }

}

export function getClassModifierForConfidence(confidence){
  if(confidence <= 20){
    return 'none';
  }
  else if(confidence <= 40){
    return 'low';
  }
  else if(confidence <= 65){
    return 'medium';
  }
  else{
    return 'high';
  }
}

export function getColorForCondifence(confidence){
  if(confidence <= 20){
    return '#929896';
  }
  else if(confidence <= 40){
    return '#545B72';
  }
  else if(confidence <= 65){
    return '#4A7853';
  }
  else{
    return '#2D9542';
  }
}



// WEBPACK FOOTER //
// ./src/util/dealScoring.js